import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'saldoBg',
})
export class SaldoBgPipe implements PipeTransform {
  transform(saldo: number): string {
    return saldo < 0 ? 'bg-danger-soft' : 'bg-success-soft';
  }
}
